var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiemens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 20,
    viewBox: "0 0 116 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.392 1.50597V4.9441C112.611 4.27168 111.025 3.93169 109.637 3.93169C108.815 3.93169 108.161 4.08393 107.668 4.37826C107.176 4.67513 106.925 5.04054 106.925 5.47189C106.925 6.04533 107.481 6.55531 108.6 7.01208L111.832 8.58525C114.446 9.83112 115.742 11.4854 115.742 13.5636C115.742 15.2915 115.055 16.6693 113.667 17.6893C112.289 18.7196 110.434 19.2295 108.125 19.2295C107.059 19.2295 106.103 19.1839 105.253 19.0874C104.403 18.9961 103.426 18.8083 102.342 18.5394V14.9414C104.329 15.6138 106.138 15.9538 107.767 15.9538C109.711 15.9538 110.678 15.3905 110.678 14.2537C110.678 13.6879 110.282 13.2312 109.477 12.8734L105.887 11.3434C104.563 10.7445 103.578 10.0189 102.934 9.1587C102.299 8.29092 101.977 7.29627 101.977 6.15953C101.977 4.56855 102.647 3.28718 103.971 2.31282C105.306 1.34606 107.077 0.86145 109.28 0.86145C109.995 0.86145 110.82 0.924859 111.733 1.04159C112.654 1.16593 113.54 1.31816 114.392 1.50597Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7043 1.50597V4.9441C10.923 4.27168 9.33973 3.93169 7.95177 3.93169C7.12711 3.93169 6.47504 4.08393 5.98276 4.37826C5.49054 4.67513 5.23932 5.04054 5.23932 5.47189C5.23932 6.04533 5.80262 6.55531 6.92161 7.01208L10.1542 8.58525C12.7576 9.83112 14.0568 11.4854 14.0568 13.5636C14.0568 15.2915 13.3666 16.6693 11.9888 17.6893C10.6008 18.7196 8.75614 19.2295 6.43953 19.2295C5.37381 19.2295 4.41467 19.1839 3.56465 19.0874C2.71462 18.9961 1.74787 18.8083 0.656843 18.5394V14.9414C2.65122 15.6138 4.46038 15.9538 6.0792 15.9538C8.02285 15.9538 8.9896 15.3905 8.9896 14.2537C8.9896 13.6879 8.59629 13.2312 7.79953 12.8734L4.20917 11.3434C2.87447 10.7445 1.88997 10.0189 1.25565 9.1587C0.61113 8.29092 0.296509 7.29627 0.296509 6.15953C0.296509 4.56855 0.96132 3.28718 2.29342 2.31282C3.61797 1.34606 5.39156 0.86145 7.59403 0.86145C8.31718 0.86145 9.13169 0.924859 10.0553 1.04159C10.9688 1.16593 11.8543 1.31816 12.7043 1.50597Z",
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4089 1.18359H21.674V18.9072H16.4089V1.18359Z",
    fill: "#E3E3E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6363 1.18359V4.4594H30.8136V8.38975H37.5986V11.3433H30.8136V15.4691H38.7962V18.9072H25.7465V1.18359H38.6363Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2159 1.18359V18.9072H58.3007V7.2175L53.2009 19.0696H50.1662L45.2614 7.2175V18.9072H41.7066V1.18359H48.1337L52.5209 12.0334L57.111 1.18359H63.2159Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1709 1.18359V4.4594H72.3909V8.38975H79.1758V11.3433H72.3909V15.4691H80.3307V18.9072H67.2811V1.18359H80.1709Z",
    fill: "#E3E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6453 1.18359V18.9072H93.0607L86.7936 7.53973V18.9072H83.241V1.18359H88.9884L95.0933 12.3557V1.18359H98.6453Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiemens);
export default __webpack_public_path__ + "static/media/Siemens.2d695c826adabcb5a5a8d0574c435bc3.svg";
export { ForwardRef as ReactComponent };